import http from "../../utils/http"

/**
 * ไม่ว่าจะทําตามผลิตภัณฑ์
 * @param {object} params
 */
export function isCollect(params) {
    return http({
        url: "/api/goodscollect/iscollect",
        data: params,
        forceLogin: true
    })
}

/**
 * เพิ่มสินค้าตาม
 * @param {Object} params
 */
export function addCollect(params) {
    return http({
        url: "/api/goodscollect/add",
        data: params,
        forceLogin: true
    })
}

/**
 * ลบผลิตภัณฑ์ต่อไปนี้
 * @param {Object} params
 */
export function deleteCollect(params) {
    return http({
        url: "/api/goodscollect/delete",
        data: params,
        forceLogin: true
    })
}
